import { widgetInitializedSymbol } from '../WidgetData.js'

export function readyDirective(el: Node, { expression }: any, { evaluate, cleanup }: any) {
  evaluate(async function () {
    // @ts-ignore
    this.$ready.then(() => {
      evaluate(expression)
    })
  })
}
